// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"afe03ece","240":"c7c3bd27","396":"1eae23fb"}[chunkId] + ".chunk.js";
};